<template>
  <div class="main" style="margin: 0;">

    <div class="title flex_c">
      <!--<div class="logo"></div>-->
      <div class="txt">企业经营驾驶舱</div>
    </div>

    <div class="tips">
      您好，今天是{{ YEAR }}年{{ MONTH }}月{{ DAY }}日，本月已经过去了{{ PERCENT }}%
    </div>

    <div class="row row0 flex_b">
      <div class="col_big card">
        <div class="ftit">运费额</div>
        <div class="row flex_b" style="margin: 15px 0 5px;">
          <div class="label">公司运费</div>
          <div class="value" style="margin: 0">{{ yfze.yfze }}</div>
        </div>
        <div class="row flex_b">
          <div class="label">司机运费</div>
          <div class="value" style="margin: 0">{{ sjyfze.sjyfze }}</div>
        </div>
      </div>

      <div class="col_big card">
        <div class="ftit">利润额</div>
        <div class="row flex_b" style="margin: 15px 0 5px;">
          <div class="label">公司利润</div>
          <div class="value" style="margin: 0">{{ gszlr.gszlr }}</div>
        </div>
        <div class="row flex_b">
          <div class="label">司机利润</div>
          <div class="value" style="margin: 0">{{ zlr.zlr }}</div>
        </div>
      </div>

      <div class="col_small card">
        <div class="label">本月订单量</div>
        <div class="value">{{ zddl.zddl }}</div>
        <div class="diff flex_c">
          <TongBi :num="zddl.tbzddl" />
          <TongBi :num="zddl.hbzddl" :type="1" />
        </div>
      </div>

      <div class="col_small card">
        <div class="label">出车费用</div>
        <div class="value">{{ cczfy.cczfy }}</div>
        <div class="diff flex_c">
          <TongBi :num="cczfy.tbcczfy" />
          <TongBi :num="cczfy.hbcczfy" :type="1" />
        </div>
      </div>

      <div class="col_small card">
        <div class="label">固定费用</div>
        <div class="value">{{ gdzfy.gdzfy }}</div>
        <div class="diff flex_c">
          <TongBi :num="gdzfy.tbgdzfy" />
          <TongBi :num="gdzfy.hbgdzfy" :type="1" />
        </div>
      </div>

      <div class="col_small card">
        <div class="label">维修费用</div>
        <div class="value">{{ wxzfy.wxzfy }}</div>
        <div class="diff flex_c">
          <TongBi :num="wxzfy.tbwxzfy" />
          <TongBi :num="wxzfy.hbwxzfy" :type="1" />
        </div>
      </div>
    </div>

    <div class="row row1 flex_b">
      <div class="col_small card flex" @click="goClient">
        <div class="left">
          <div class="con" id="chart0"></div>
          <div class="chart_mask">
            <div class="up flex_c">
              <div class="val">{{ activation }}</div>
              <div class="per">%</div>
            </div>
            <div class="txt">客户活跃度</div>
          </div>
        </div>

        <div class="right">
          <div class="item up">
            <div class="label flex">
              <div class="ico"></div>
              <div class="txt">客户总量</div>
            </div>
            <div class="value">{{ customall }}</div>
          </div>
          <div class="item down">
            <div class="label flex">
              <div class="ico"></div>
              <div class="txt">近30天活跃客户数量</div>
            </div>
            <div class="value">{{ customactive }}</div>
          </div>
        </div>
      </div>

      <div class="col_big card flex">
        <div class="part1 flex" @click="goCarManage">
          <div class="left">
            <div class="con" id="chart1"></div>
            <div class="chart_mask">
              <div class="up flex_c">
                <div class="val">{{ intransitratio }}</div>
                <div class="per">%</div>
              </div>
              <div class="txt">在途率</div>
            </div>
          </div>

          <div class="right">
            <div class="item up flex">
              <div class="i0">
                <div class="label flex">
                  <div class="ico"></div>
                  <div class="txt">车辆总数</div>
                </div>
                <div class="value">{{ carcount }}</div>
              </div>
              <div class="i1">
                <div class="label flex">
                  <div class="ico"></div>
                  <div class="txt">在途车辆数量</div>
                </div>
                <div class="value">{{ usercar }}</div>
              </div>
            </div>
            <div class="item down">
              <div class="label flex">
                <div class="ico"></div>
                <div class="txt">账面资产总额</div>
              </div>
              <div class="value">{{ money }}</div>
            </div>
          </div>
        </div>
        <div class="part2 flex_b">
          <div class="left">
            <RadioGroup :options="radioData" @radioChange="radioChange">
              <template #start>
                <div class="ico"></div>
              </template>
              <template #end="params">
                <div class="val">{{ params.params.val }}</div>
              </template>
            </RadioGroup>
          </div>
          <div class="right circle">
            <div class="con flex_c" id="chart2"></div>
            <div class="mask"></div>
          </div>
        </div>
      </div>

      <div class="col_small card flex col_s_2" @click="goErrManage">
        <div class="left flex_b">
          <div class="item item1">
            <div class="label">待处理异常</div>
            <div class="value">{{ abnormalwait }}</div>
          </div>
          <div class="item">
            <div class="label">异常总数</div>
            <div class="value">{{ abnormalall }}</div>
          </div>
        </div>
        <div class="right circle">
          <div class="con flex_c" id="chart3"></div>
          <div class="mask"></div>
        </div>
      </div>
    </div>

    <div class="row row2 flex_b">
      <div class="card col1">
        <div class="tit">
          <div class="left">近12月运费走势图</div>
        </div>
        <div class="cont">
          <div class="chart" id="chart4"></div>
        </div>
      </div>

      <div class="card col2">
        <div class="tit">
          <div class="left">目标达成</div>
        </div>
        <div class="cont">
          <div class="chart" id="chart5"></div>
        </div>
      </div>

      <div class="card col3">
        <div class="tit flex_b">
          <div class="left">维修分析</div>
          <div class="right flex">
            <div class="lab">今年已经过去了</div>
            <div class="val">{{ past }}</div>
          </div>
        </div>
        <div class="cont">
          <div class="up flex_c">
            <div class="item flex_b" @click="goCurrYearFixList">
              <div class="lab">今年维修费用</div>
              <div class="val">{{ fixfee }}</div>
            </div>
            <div class="item flex_b item1" @click="goPrevYearFixList">
              <div class="lab">去年维修费用</div>
              <div class="val">{{ fixfee2 }}</div>
            </div>
          </div>

          <div class="down flex">
            <div class="left">
              <div class="chart" id="chart6"></div>
            </div>
            <div class="right circle">
              <div class="con" id="chart7"></div>
              <div class="mask"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row3 flex_b">
      <div class="card col1">
        <div class="tit flex_b">
          <div class="left">财务指标分析</div>

          <div class="right flex">
            <RadioGroup :options="fleetData" @radioChange="fleetChange"></RadioGroup>
          </div>
        </div>
        <div class="cont flex">
          <div class="left flex">
            <div class="item card">
              <div class="label">本年运费总额</div>
              <div class="value">{{ yfze2.yfze }}</div>
              <div class="diff flex_c">
                <TongBi :num="yfze2.tb" />
                <!-- <TongBi :num="yfze2.hb" :type="1" /> -->
              </div>
            </div>

            <div class="item card">
              <div class="label">本年毛利额</div>
              <div class="value">{{ mle.mle }}</div>
              <div class="diff flex_c">
                <TongBi :num="mle.tb" />
                <!-- <TongBi :num="mle.hb" :type="1" /> -->
              </div>
            </div>

            <div class="item card">
              <div class="label">营业成本率</div>
              <div class="value">{{ yycbl.yycbl }}%</div>
              <div class="diff flex_c">
                <TongBi :num="yycbl.tb" />
                <!-- <TongBi :num="yycbl.hb" :type="1" /> -->
              </div>
            </div>

            <div class="item card">
              <div class="label">本年毛利率</div>
              <div class="value">{{ mll.mll }}%</div>
              <div class="diff flex_c">
                <TongBi :num="mll.tb" />
                <!-- <TongBi :num="mll.hb" :type="1" /> -->
              </div>
            </div>

            <div class="item card">
              <div class="label">人力成本率</div>
              <div class="value">{{ rlcbl.rlcbl }}%</div>
              <div class="diff flex_c">
                <TongBi :num="rlcbl.tb" />
                <!-- <TongBi :num="rlcbl.hb" :type="1" /> -->
              </div>
            </div>

            <div class="item card">
              <div class="label">物流成本率</div>
              <div class="value">{{ wlcbl.wlcbl }}%</div>
              <div class="diff flex_c">
                <TongBi :num="wlcbl.tb" />
                <!-- <TongBi :num="wlcbl.hb" :type="1" /> -->
              </div>
            </div>
          </div>

          <div class="right flex">
            <div class="item items circle" @click="goCarFee">
              <div class="con" id="chart8"></div>
              <div class="mask"></div>
            </div>
            <div class="item circle" @click="goFixFee">
              <div class="con" id="chart9"></div>
              <div class="mask"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="card col2">
        <div class="tit">
          <div class="left">人力资源分析</div>
        </div>
        <div class="cont">
          <div class="up flex_b" @click="goStaffList">
            <div class="l flex">
              <div class="lab">员工总数</div>
              <div class="val">{{ ygzs }}</div>
            </div>
            <div class="r flex_b">
              <div class="item flex_b">
                <div class="lab">本月入职</div>
                <div class="val">{{ byrz }}</div>
              </div>
              <div class="item flex_b">
                <div class="lab">本年入职</div>
                <div class="val">{{ bnrz }}</div>
              </div>
              <div class="item flex_b">
                <div class="lab">本月离职</div>
                <div class="val">{{ bylz }}</div>
              </div>
              <div class="item flex_b">
                <div class="lab">本年离职</div>
                <div class="val">{{ bnlz }}</div>
              </div>
            </div>
          </div>
          <div class="down flex">
            <div class="item circle">
              <div class="con" id="chart10"></div>
              <div class="mask"></div>
            </div>
            <div class="item circle">
              <div class="con" id="chart11"></div>
              <div class="mask"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TongBi from "../components/TongBi.vue";

export default {
  name: "Index",
  // mixins: [tableMixin],
  components: {
    TongBi,
  },
  data() {
    return {
      baseUrl: 'cockpit',
      fleetData: [
        { label: '全部', value: 0 },
      ],
      chart0: null,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      chart5: null,
      chart6: null,
      chart7: null,
      chart8: null,
      chart9: null,
      chart10: null,
      chart11: null,
      gszlr: {
        gszlr: 0,
      },
      sjyfze: {
        sjyfze: 0,
      },
      yfze: {
        yfze: 0,
      },
      zlr: {
        zlr: 0,
      },
      "zddl": {
        "zddl": 0,
        "tbzddl": 0,
        "hbzddl": 0
      },
      "cczfy": {
        "cczfy": 0,
        "tbcczfy": 0,
        "hbcczfy": 0
      },
      "gdzfy": {
        "gdzfy": 0,
        "tbgdzfy": 0,
        "hbgdzfy": 0
      },
      "wxzfy": {
        "wxzfy": 0,
        "tbwxzfy": 0,
        "hbwxzfy": 0
      },
      activation: 0,
      customall: 0,
      customactive: 0,
      intransitratio: 0,//在途率
      carcount: 0,//车辆总数
      usercar: 0,//在途车辆数量
      money: 0,//账面资产总额
      radioData: [],
      fleetmonthdays: [],
      fleetyeardays: [],
      abnormal: [],
      abnormalwait: 0,
      abnormalall: 0,
      past: '0%',
      fixfee: 0,
      fixfee2: 0,
      yfze2: {
        "yfze": 0,  // 运费总额
        "wqyfze": 0,
        "tb": 0, // 同比
        "hb": 0	//环比
      },
      mle: {
        "mle": 0, // 毛利总额
        "wqmle": 0,
        "tb": 0,
        "hb": 0
      },
      yycbl: {
        "yycbl": 0,
        "tb": 0,
        "hb": 0
      },
      mll: {
        "mll": 0,
        "tb": 0,
        "hb": 0
      },
      rlcbl: {
        "rlcbl": 0,
        "tb": 0,
        "hb": 0
      },
      wlcbl: {
        "wlcbl": 0,
        "tb": 0,
        "hb": 0
      },
      pieLabelStyle: {
        width: 90,
        color: 'inherit', // 继承系列色
        // formatter: '{b}\n{val|{c}}',
        formatter: '{val|{c}}\n{b}',
        lineHeight: 15,
        rich: {
          // b: {
          //   overflow: 'break',
          // },
          val: {
            color: '#fff'
          },
        },
        distanceToLabelLine: 0,
        // overflow: 'break',
      },
      pieLabelLineStyle: {
        show: false,
        length: 8,
        length2: 2,
      },
      ygzs: 0,
      bnrz: 0,
      bnlz: 0,
      byrz: 0,
      bylz: 0,
      YEAR: '0000',
      MONTH: '00',
      DAY: '00',
      PERCENT: '0',
    };
  },
  methods: {
    radioChange(v) {
      console.log(v);
      // this.setData2()
      if (v == this.radioData[0].value) {
        this.setData2(this.fleetmonthdays)
      } else {
        this.setData2(this.fleetyeardays)
      }
    },
    fleetChange(v) {
      console.log(v);
      this.getChart8Data(v)
    },
    getData() {
      this.initAllChart()
      this.loading = true
      let url = `${this.baseUrl}/head`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // console.log(res)
        if (!res) {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
          return
        }
        const { yfze, zlr, zddl, cczfy, gdzfy, wxzfy, gszlr, sjyfze } = res
        gszlr && (this.gszlr = gszlr)
        sjyfze && (this.sjyfze = sjyfze)
        yfze && (this.yfze = yfze)
        zlr && (this.zlr = zlr)
        zddl && (this.zddl = zddl)
        cczfy && (this.cczfy = cczfy)
        gdzfy && (this.gdzfy = gdzfy)
        wxzfy && (this.wxzfy = wxzfy)
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getChart1Data() {
      this.loading = true
      let url = `${this.baseUrl}/secondline`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // console.log(res)
        if (!res) {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
          return
        }
        const { activation, customall, customactive, intransitratio, carcount, usercar, money, monthdays, yeardays, fleetmonthdays, fleetyeardays } = res
        this.activation = activation || 0
        this.customall = customall || 0
        this.customactive = customactive || 0
        this.intransitratio = intransitratio || 0
        this.carcount = carcount || 0
        this.usercar = usercar || 0
        this.money = money || 0
        this.setData1(activation, intransitratio)
        this.radioData = [
          {
            label: '本月累计空闲天数',
            value: '0',
            val: monthdays || 0,
          },
          {
            label: '本年累计空闲天数',
            value: '1',
            val: yeardays || 0,
          },
        ]
        fleetmonthdays.map(v => {
          const obj = {}
          obj['name'] = v.nickname
          obj['value'] = v.fleetmonthdays
          this.fleetmonthdays.push(obj)
        })
        fleetyeardays.map(v => {
          const obj = {}
          obj['name'] = v.nickname
          obj['value'] = v.fleetmonthdays
          this.fleetyeardays.push(obj)
        })
        this.setData2(this.fleetmonthdays)
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getChart3Data() {
      this.loading = true
      let url = `${this.baseUrl}/abnormal`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // console.log(res)
        if (!res) {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
          return
        }
        const { abnormalwait, abnormalall, abnormal
        } = res
        this.abnormalwait = abnormalwait || 0
        this.abnormalall = abnormalall || 0
        abnormal.map(v => {
          const obj = {}
          obj['name'] = v.type
          obj['value'] = v.num
          this.abnormal.push(obj)
        })
        this.setData3(this.abnormal)
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getChart4Data() {
      this.loading = true
      let url = `${this.baseUrl}/yunfeiqs`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // console.log(res)
        if (!res) {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
          return
        }
        const data0 = []
        const data1 = []
        const data2 = []
        const data3 = []
        if (Array.isArray(res)) {
          res.map(v => {
            // console.log(v)
            data0.push(v.month)
            data1.push(v.total_yf)
            data2.push(v.total_mle)
            data3.push(v.total_mll.replace('%', ''))
          })
        }
        this.setData4(data0, data1, data2, data3)
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getChart5Data() {
      this.loading = true
      let url = `${this.baseUrl}/cartarget`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // console.log(res)
        if (!res) {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
          return
        }
        const data0 = []
        const data1 = []
        const data2 = []
        if (res.fleet && Array.isArray(res.fleet)) {
          res.fleet.map(v => {
            // console.log(v)
            data0.push(v.name)
            data1.push(v.freight)
            data2.push(v.cartarget)
          })
        }
        this.setData5(data0, data1, data2)
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getChart6Data() {
      this.loading = true
      let url = `${this.baseUrl}/wxfxline`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // console.log(res)
        if (!res) {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
          return
        }
        this.past = res['Year%']
        this.fixfee = res['今年维修费用']
        this.fixfee2 = res['往年维修费用']
        const data0 = []
        const data1 = []
        const data2 = []
        const o1 = res['车队长消费额']
        if (o1) {
          for (const key in o1) {
            if (Object.hasOwnProperty.call(o1, key)) {
              const value = o1[key];
              // const o = {
              //   name: key,
              //   value,
              // }
              data0.push(key)
              data1.push(value)
            }
          }
        }
        const o2 = res['维修费用类型']
        if (o2) {
          for (const key in o2) {
            if (Object.hasOwnProperty.call(o2, key)) {
              const value = o2[key];
              const o = {
                name: key,
                value,
              }
              data2.push(o)
            }
          }
        }
        this.setData6(data0, data1)
        this.setData7(data2)
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getFleetData() {
      this.loading = true
      let url = `${this.baseUrl}/getDzlist`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // console.log(res)
        if (!res) {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
          return
        }
        if (Array.isArray(res)) {
          res.map(v => {
            // console.log(v)
            const o = {
              label: v.name,
              value: v.userid,
            }
            if (v.iswork == '在职') {
              this.fleetData.push(o)
            }
          })
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getChart8Data(id) {
      this.loading = true
      let url = `${this.baseUrl}/moneyfx`;
      const params = {
        // userid: this.user.id,
      }
      id && (params['userid'] = id)
      this.post(url, params, (res) => {
        // console.log(res)
        if (!res) {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
          return
        }
        this.yfze2 = res['运费总额']
        this.mle = res['毛利额']
        this.yycbl = res['营业成本率']
        this.mll = res['毛利率']
        this.rlcbl = res['人力成本率']
        this.wlcbl = res['物流成本率']
        const data1 = []
        const data2 = []
        const o1 = res['出车费用概况']
        const o2 = res['固定费用概况']
        if (o1) {
          for (const key in o1) {
            if (Object.hasOwnProperty.call(o1, key)) {
              const value = o1[key];
              const o = {
                name: key,
                value,
              }
              data1.push(o)
            }
          }
        }
        if (o2) {
          for (const key in o2) {
            if (Object.hasOwnProperty.call(o2, key)) {
              const value = o2[key];
              const o = {
                name: key,
                value,
              }
              data2.push(o)
            }
          }
        }
        this.setData8(data1)
        this.setData9(data2)
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getChart10Data() {
      this.loading = true
      let url = `${this.baseUrl}/renlizy`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // console.log(res)
        if (!res) {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
          return
        }
        this.ygzs = res['员工总数']
        this.bnrz = res['本年入职']
        this.bnlz = res['本年离职']
        this.byrz = res['本月入职']
        this.bylz = res['本月离职']
        const data0 = []
        const data1 = []
        // const o1 = res['后勤岗位人数'].parent
        // if (o1) {
        //   for (const key in o1) {
        //     if (Object.hasOwnProperty.call(o1, key)) {
        //       const value = o1[key];
        //       const o = {
        //         name: key,
        //         value,
        //       }
        //       data0.push(o)
        //     }
        //   }
        // }
        data0.push({
          name: '后勤岗位人数',
          value: res['后勤岗位人数']['总人数'],
        })
        data0.push({
          name: '业务岗位人数',
          value: res['业务岗位人数']['总人数'],
        })
        // console.log(data0)
        const o2 = res['业务岗位人数'].parent
        if (o2) {
          for (const key in o2) {
            if (Object.hasOwnProperty.call(o2, key)) {
              const value = o2[key];
              const o = {
                name: key,
                value,
              }
              data1.push(o)
            }
          }
        }
        this.setData10(data0)
        this.setData11(data1)
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    initDate() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      this.YEAR = y
      this.MONTH = m
      this.DAY = d
      // m > 9 ? null : m = '0' + m
      // d > 9 ? null : d = '0' + d
      // console.log((d / 28).toFixed(2), (d / 29).toFixed(2), (d / 30).toFixed(2), (d / 31).toFixed(2))
      let per = d / 28
      if (m == 2) {
        if ((y % 4 == 0 && y % 100 != 0) || (y % 400 == 0)) {
          per = d / 29
        }
      } else if ([1, 3, 5, 7, 8, 10, 12].includes(m)) {
        per = d / 31
      } else {
        per = d / 30
      }
      this.PERCENT = (per * 100).toFixed(2)
    },
    initAllChart() {
      this.initDate()
      // 客户活跃度仪表盘初始化
      this.chart0 = this.$echarts.init(document.getElementById('chart0'));
      // 在途率仪表盘初始化
      this.chart1 = this.$echarts.init(document.getElementById('chart1'));
      // 空闲天数环形图
      this.chart2 = this.$echarts.init(document.getElementById('chart2'));
      // this.chart2.showLoading()
      this.chart3 = this.$echarts.init(document.getElementById('chart3'));
      this.chart4 = this.$echarts.init(document.getElementById('chart4'));
      // 目标达成柱状图
      this.chart5 = this.$echarts.init(document.getElementById('chart5'));
      this.chart5.on('click', (params) => {
        // console.log(params)
        const { dataIndex, name } = params
        // console.log(dataIndex, name)
        this.$router.push(`/finance/feightStatistics?fleetName=${name}&fleetIdx=${dataIndex}`)
      })
      // 维修分析柱状图
      this.chart6 = this.$echarts.init(document.getElementById('chart6'));
      const goFixList = this.goFixList
      const range = this.getMonthRange()
      this.chart6.on('click', function (params) {
        console.log('点击项名称:', params.name);
        // console.log(`${y}-${m}-${d}`);
        // console.log('数据值:', params.value);
        // console.log('数据索引:', params.dataIndex);
        goFixList({
          fleetname: params.name,
          ...range,
        })
      })
      // 维修分析环形图
      this.chart7 = this.$echarts.init(document.getElementById('chart7'));
      this.chart7.on('click', function (params) {
        console.log('点击项名称:', params.name);
        // console.log(`${y}-${m}-${d}`);
        // console.log('数据值:', params.value);
        // console.log('数据索引:', params.dataIndex);
        goFixList({
          name: params.name,
          ...range,
        })
      })
      this.chart8 = this.$echarts.init(document.getElementById('chart8'));
      this.chart9 = this.$echarts.init(document.getElementById('chart9'));
      this.chart10 = this.$echarts.init(document.getElementById('chart10'));
      this.chart11 = this.$echarts.init(document.getElementById('chart11'));
    },
    getMonthRange() {
      let y = this.YEAR
      let m = this.MONTH
      let d = this.DAY
      m > 9 ? null : m = '0' + m
      d > 9 ? null : d = '0' + d
      return {
        months: `${y}-01-01`,
        monthe: `${y}-${m}-${d}`,
      }
    },
    setData1(v1, v2) {
      // console.log(v1, v2)
      // 仪表盘配置项
      const option = {
        series: [
          {
            type: 'gauge', // 仪表盘
            center: ['50%', '50%'], // 图形坐标位置 左, 右
            radius: '100%', // 控制饼图的大小
            startAngle: -90, // 开始位置
            endAngle: 270, // 结束位置
            pointer: { // 显示仪表盘指针
              show: false // 是否显示仪表盘指针
            },
            axisLine: { // 仪表盘轴线相关配置
              show: true,
              roundCap: true,
              // 设置线条
              lineStyle: {
                width: 12, // 线条宽度
                color: [
                  [1, '#2F3E50'],
                ], // 不透明度, 线条设置背景色
              }
            },
            progress: { // 展示当前进度。
              show: true, // 是否展示进度条
              overlap: false, // 是否重叠
              roundCap: false, // 是否圆顶
              clip: false, // 是否裁掉超出部分
              itemStyle: {
                // 进度条样式
                color: '#2DD2A5', // 设置进度条初期式样
              }
            },
            splitLine: { // 分隔线样式。
              show: false, // 是否显示分隔线。
            },
            axisTick: { // 刻度样式。
              show: false, // 是否显示刻度。
            },
            axisLabel: { //刻度标签。
              show: false, // 是否显示标签。
            },
            data: [
              {
                // name: '客户活跃度',
                value: v1, // 可写变量
                detail: {  // 仪表盘边框数据详情，用于显示数据。
                  show: false,
                  valueAnimation: true, // 是否开启标签的数字动画。
                  offsetCenter: ['0%', '0%'], // 相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移。可以是绝对的数值，也可以是相对于仪表盘半径的百分比。
                  fontSize: 22, // 文字的字体大小。
                  color: '#F3F9FF', // 文本颜色，默认取数值所在的区间的颜色
                  formatter: '{value}{a|%}', // 格式化函数或者字符串  formatter: function (value) { return value.toFixed(0);}
                  // width: 20,
                  // height: 14,
                  // fontSize: 14,
                  // borderColor: 'auto',
                  // borderRadius: 20,
                  // borderWidth: 1,
                  rich: {
                    a: {
                      fontSize: 12,
                      color: '#F3F9FF',
                      lineHeight: 96,
                    }
                  },
                  fontWeight: 'normal',
                  textShadowColor: '#159AFF',
                  textShadowBlur: 9,
                }
              }
            ],
          }
        ]
      }
      // 深拷贝一份，修改颜色
      const option1 = JSON.parse(JSON.stringify(option))
      // console.log(option1.series)
      option1.series[0].progress.itemStyle.color = '#1496FB'
      option1.series[0].data[0].value = v2
      // 客户活跃度设置
      this.chart0.setOption(option)
      // 在途率设置
      this.chart1.setOption(option1)
    },
    setData2(data) {
      // 环形图配置项
      const option = {
        series: [
          {
            type: 'pie',
            radius: [28, 40],
            label: {
              ...this.pieLabelStyle,
            },
            labelLine: {
              ...this.pieLabelLineStyle,
            },
            color: ['#E9A642', '#58A55C', '#1496FB', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
            data,
          }
        ]
      };
      this.chart2.setOption(option)
    },
    setData3(data) {
      // console.log(data)
      // 环形图配置项
      const option = {
        series: [
          {
            type: 'pie',
            radius: [28, 40],
            label: {
              ...this.pieLabelStyle,
            },
            labelLine: {
              ...this.pieLabelLineStyle,
            },
            color: ['#E9A642', '#58A55C', '#1496FB', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
            data,
          }
        ]
      };
      this.chart3.setOption(option)
    },
    setData4(data0, data1, data2, data3) {
      // console.log(data0, data1, data2, data3)
      // 堆叠柱状折线组合图配置项
      const option = {
        grid: {
          // left: 46,
          // right: 46,
          left: 50,
          right: 50,
          bottom: 38,
        },
        legend: {
          show: true,
          left: 'center',
          top: 15,
          itemGap: 20,
          data: [
            '运费额',
            '毛利额',
            '毛利率',
          ],
          textStyle: {
            color: '#6C8097',
          },
        },
        xAxis: {
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            width: 30,
            overflow: 'break',
          },
          data: data0,
        },
        yAxis: [
          {
            type: 'value',
            name: '单位：万元',
            nameGap: 23,
            // interval: 500,
            splitNumber: 5,
            splitLine: {
              show: false,
            }
          },
          {
            type: 'value',
            splitNumber: 5,
            axisLabel: {
              show: true,
              interval: 'auto',//居中显示
              formatter: '{value} %'//以百分比显示
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(108,128,151,0.3)',
              },
            }
          },
        ],
        series: [
          {
            name: '运费额',
            type: 'bar',
            barWidth: '16px',
            yAxisIndex: 0,
            itemStyle: {
              color: '#1598FB'
            },
            data: data1,
          },
          {
            name: '毛利额',
            type: 'bar',
            barWidth: '16px',
            barGap: '-100%',
            yAxisIndex: 0,
            itemStyle: {
              color: '#2DD2A5'
            },
            data: data2,
          },
          {
            name: '毛利率',
            type: 'line',
            yAxisIndex: 1,
            itemStyle: {
              color: '#EF6F2E',
            },
            smooth: true,
            data: data3,
          },
        ]
      };
      this.chart4.setOption(option)
    },
    setData5(data0, data1, data2) {
      // console.log(data0, data1, data2)
      // 柱状图配置项
      const option = {
        grid: {
          // left: 46,
          right: 19,
          left: 50,
          bottom: 38,
        },
        legend: {
          show: true,
          left: 'center',
          top: 15,
          itemGap: 20,
          data: [
            '实际运费额',
            '目标运费额',
          ],
          textStyle: {
            color: '#6C8097',
          },
        },
        xAxis: {
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            interval: 0,
          },
          data: data0,
        },
        yAxis: {
          type: 'value',
          name: '单位：万元',
          nameGap: 23,
          splitNumber: 5,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(108,128,151,0.3)',
            },
          }
        },
        series: [
          {
            name: '实际运费额',
            type: 'bar',
            barWidth: '16px',
            itemStyle: {
              color: '#1598FB'
            },
            data: data1,
          },
          {
            name: '目标运费额',
            type: 'bar',
            barWidth: '16px',
            itemStyle: {
              color: '#EFBB6D'
            },
            data: data2,
          },
        ]
      };
      this.chart5.setOption(option)
    },
    setData6(data0, data1) {
      // console.log(data0, data1)
      // 柱状图配置项
      const option = {
        grid: {
          top: 31,
          left: 56,
          right: 0,
          bottom: 38,
        },
        legend: {
          show: false,
        },
        xAxis: {
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            interval: 0,
          },
          data: data0,
        },
        yAxis: {
          type: 'value',
          // name: '单位：万元',
          // nameGap: 23,
          splitNumber: 5,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(108,128,151,0.3)',
            },
          }
        },
        series: [
          {
            type: 'bar',
            barWidth: '16px',
            itemStyle: {
              color: '#E17339'
            },
            data: data1,
          },
        ]
      };
      this.chart6.setOption(option)
    },
    setData7(data) {
      // 环形图配置项
      const option = {
        series: [
          {
            type: 'pie',
            radius: [28, 40],
            label: {
              ...this.pieLabelStyle,
              overflow: 'break',
              width: 60,
            },
            labelLine: {
              ...this.pieLabelLineStyle,
              length: 2,
              length2: 2,
            },
            color: ['#FFC97A', '#2DD2A5', '#1598FB', '#58A55C', '#7F83F7', '#fc8452', '#9a60b4', '#ea7ccc'],
            data,
          }
        ]
      };
      this.chart7.setOption(option)
    },
    setData8(data) {
      // 环形图配置项
      const option = {
        title: {
          text: '出车费用概况',
          bottom: 20,
          left: 'center',
          textStyle: {
            color: '#F3F9FF',
            fontSize: 14,
            fontWeight: 400,
          },
        },
        series: [
          {
            type: 'pie',
            radius: [44, 60], // 内径，外径
            label: {
              ...this.pieLabelStyle,
            },
            labelLine: {
              ...this.pieLabelLineStyle,
            },
            color: ['#FFC97A', '#E9A642', '#1598FB', '#58A55C', '#7F83F7', '#EE752F', '#fc8452', '#9a60b4', '#ea7ccc'],
            data,
          }
        ]
      };
      this.chart8.setOption(option)
    },
    setData9(data) {
      // 环形图配置项
      const option = {
        title: {
          text: '固定费用概况',
          bottom: 20,
          left: 'center',
          textStyle: {
            color: '#F3F9FF',
            fontSize: 14,
            fontWeight: 400,
          },
        },
        series: [
          {
            type: 'pie',
            radius: [44, 60], // 内径，外径
            label: {
              ...this.pieLabelStyle,
              overflow: 'break',
              width: 60,
            },
            labelLine: {
              ...this.pieLabelLineStyle,
            },
            color: ['#2DDAE6', '#5087EC', '#2DD285', '#E9A642', '#EE752F', '#D95040', '#fc8452', '#9a60b4', '#ea7ccc'],
            data,
          }
        ]
      };
      this.chart9.setOption(option)
    },
    setData10(data) {
      // 环形图配置项
      const option = {
        title: {
          text: '员工构成',
          bottom: 0,
          left: 'center',
          textStyle: {
            color: '#F3F9FF',
            fontSize: 12,
            fontWeight: 400,
          },
        },
        series: [
          {
            type: 'pie',
            radius: [28, 40], // 内径，外径
            label: {
              ...this.pieLabelStyle,
              overflow: 'break',
              width: 80,
            },
            labelLine: {
              ...this.pieLabelLineStyle,
            },
            color: ['#1598FB', '#2DD2A5', '#2DD285', '#E9A642', '#EE752F', '#D95040', '#fc8452', '#9a60b4', '#ea7ccc'],
            data,
          }
        ]
      };
      this.chart10.setOption(option)
    },
    setData11(data) {
      // 环形图配置项
      const option = {
        title: {
          text: '业务岗位构成',
          bottom: 0,
          left: 'center',
          textStyle: {
            color: '#F3F9FF',
            fontSize: 12,
            fontWeight: 400,
          },
        },
        series: [
          {
            type: 'pie',
            radius: [28, 40], // 内径，外径
            label: {
              ...this.pieLabelStyle,
            },
            labelLine: {
              ...this.pieLabelLineStyle,
            },
            color: ['#5087EC', '#68BBC4', '#58A55C', '#E9A642', '#EE752F', '#D95040', '#fc8452', '#9a60b4', '#ea7ccc'],
            data,
          }
        ]
      };
      this.chart11.setOption(option)
    },
    goClient() {
      this.$router.push(`/customer/manage`)
    },
    goCarManage() {
      this.$router.push(`/vehicle/manage`)
    },
    goErrManage() {
      this.$router.push(`/finance/financeFleetAbnormal`)
    },
    goCurrYearFixList() {
      // console.log(query)
      const y = this.YEAR
      this.$router.push({
        path: `/fix/list`,
        query: {
          months: `${y}-01-01`,
          monthe: `${y}-12-31`,
        },
      })
    },
    goPrevYearFixList() {
      // console.log(query)
      const date = new Date()
      const y = date.getFullYear() - 1
      this.$router.push({
        path: `/fix/list`,
        query: {
          months: `${y}-01-01`,
          monthe: `${y}-12-31`,
        },
      })
    },
    goFixList(query) {
      // console.log(query)
      this.$router.push({
        path: `/fix/list`,
        query,
      })
    },
    goCarFee() {
      this.$router.push(`/finance/expenseSummary`)
    },
    goFixFee() {
      this.$router.push(`/finance/fixedFeeList`)
    },
    goStaffList() {
      this.$router.push(`/staff/manager`)
    },
    setHeight() {
      const boxh = document.getElementsByClassName("main")[0]?.offsetHeight
      const toph = document.getElementsByClassName("top")[0]?.offsetHeight
      const h = (boxh - toph) / 2 - 90
      // console.log(boxh, toph)
      // console.log(h)
      const arr = [...document.querySelectorAll(".left .item .fg")]
      arr.map(v => {
        v.style.height = h + 'px'
      })
    },
  },
  mounted() {
    this.getData()
    this.getChart1Data()
    this.getChart3Data()
    this.getChart4Data()
    this.getChart5Data()
    this.getChart6Data()
    this.getFleetData()
    this.getChart8Data()
    this.getChart10Data()
    // this.setHeight()
    // setInterval(function () {
    //   location.reload();
    // }, 600000);
  },
};
</script>

<style lang="less" scoped>
.main {
  background: url(../assets/img/index_bg.png) no-repeat center center/cover;
  position: relative;
  overflow: hidden;

  // position: fixed;
  // left: 0;
  // top: 0;
  // width: 100%;
  // height: 100%;
  // overflow-y: scroll;

  .title {
    padding: 15px 0;
    background: url(../assets/img/index_title_bg.png) no-repeat top center;

    .logo {
      width: 151px;
      height: 43px;
      background: url(../assets/img/logo.png) no-repeat center center;
      margin-right: 10px;
    }

    .txt {
      height: 43px;
      line-height: 43px;
      font-size: 36px;
      font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
      font-weight: 400;
      color: #FFFFFF;
      letter-spacing: 10px;
      text-shadow: 0px 0px 20px #159AFF;
    }
  }

  .tips {
    position: absolute;
    right: 30px;
    left: auto;
    top: 58px;
    font-size: 16px;
    font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
    font-weight: 400;
    color: #F3F9FF;
  }

  .flex {
    display: flex;
  }

  .flex_c {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flex_b {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .card {
    background: rgba(15, 24, 42, 0.9);
    box-sizing: border-box;

    .tit {
      width: 100%;
      height: 48px;
      line-height: 48px;
      padding-left: 52px;
      background: url(../assets/img/index_tit_bg.png) no-repeat top left;
      font-size: 18px;
      color: #EBF9FF;
      position: relative;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(225, 225, 225, 0.09);

      .left {
        text-shadow: 0px 0px 9px #159AFF;
      }

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 45px;
        width: 20px;
        height: 3px;
        background: url(../assets/img/index_tit_bg_2.png) no-repeat top right;
      }
    }
  }

  .card {
    .label {
      font-size: 15px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #F3F9FF;
      height: 15px;
      line-height: 15px;
    }

    .value {
      font-size: 22px;
      font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
      font-weight: 400;
      color: #F3F9FF;
      text-shadow: 0px 0px 10px rgba(255, 201, 122, 1);
      margin-top: 10px;
      height: 26px;
      line-height: 26px;
    }

    .diff {
      margin-top: 20px;
      height: 14px;
      line-height: 14px;

      /deep/ .itemm {
        &:last-of-type {
          .ico {
            margin-right: 0;
          }
        }
      }
    }
  }

  .row0 {
    margin: 22px 30px 20px;
    // height: 11.6%;

    .col_big {
      // width: 356px;
      height: 125px;
      width: 19.1%;
      // height: 100%;
      padding: 20px 25px;
      background: rgba(15, 24, 42, 0.9) url(../assets/img/index_corner_1.png) no-repeat 5px 5px;

      &:nth-child(2) {
        background-image: url(../assets/img/index_corner_2.png);
      }

      .ftit {
        font-size: 15px;
        font-weight: 500;
        color: #F3F9FF;
        height: 15px;
        line-height: 15px;
      }

      .l {
        .value {
          text-shadow: 0px 0px 9px #159AFF;
        }
      }

      .r {
        .up {
          margin-top: -12px;
          width: 72px;
          height: 84px;
          line-height: 96px;
          background: url(../assets/img/index_row1_bg_1.png) no-repeat center center;
          text-align: center;
          font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
          align-items: baseline;

          .l1 {
            font-size: 16px;
            color: #F3F9FF;
            text-shadow: 0px 0px 9px #159AFF;
          }

          .r1 {
            font-size: 10px;
            color: #F3F9FF;
            text-shadow: 0px 0px 9px #159AFF;
          }

          &.up2 {
            background-image: url(../assets/img/index_row1_bg_2.png);
          }
        }

        .txt {
          font-size: 10px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #969AA1;
          height: 10px;
          line-height: 10px;
          text-align: center;
          margin-top: 5px;
        }
      }
    }

    .col_small {
      // width: 262px;
      height: 125px;
      width: 14.1%;
      // height: 100%;
      text-align: center;
      padding: 20px 0;
    }
  }

  .circle {
    width: 100%;
    height: 100%;
    position: relative;

    .con {
      width: 100%;
      height: 100%;
    }

    .mask {
      position: absolute;
      width: 52px;
      height: 52px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      background: url(../assets/img/index_circle_bg_1.png) no-repeat center center;
    }
  }

  .row1 {
    margin: 0 30px;
    // height: 14.1%;

    .col_small {
      // width: 450px;
      height: 152px;
      width: 24.2%;
      // height: 100%;
      padding: 22px 0;
      position: relative;
      cursor: pointer;
    }

    .card {
      .left {
        // width: 193px;
        width: 42.9%;
        height: 100%;
        position: relative;

        .con {
          width: 100%;
          height: 100%;
        }
      }

      .chart_mask {
        position: absolute;
        width: 76px;
        height: 76px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        background: url(../assets/img/index_circle_bg_0.png) no-repeat center center;

        .up {
          height: 40px;
          line-height: 60px;
          color: #F3F9FF;
          text-shadow: 0px 0px 9px #159AFF;
          align-items: baseline;

          .val {
            font-size: 22px;
          }

          .per {
            font-size: 12px;
            line-height: 66px;
          }
        }

        .txt {
          font-size: 11px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #F3F9FF;
          text-align: center;
        }
      }

      .right {
        .item {
          .label {
            align-items: center;

            .ico {
              width: 3px;
              height: 14px;
              background: linear-gradient(360deg, rgba(45, 210, 165, 0) 0%, #2DD2A5 100%);
              margin-right: 8px;
            }

            .txt {
              height: 14px;
              line-height: 14px;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #D0DEEE;
            }
          }

          .value {
            height: 19px;
            line-height: 19px;
            font-size: 16px;
            font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
            font-weight: 400;
            color: #F3F9FF;
            margin: 8px 0 20px;
          }
        }
      }
    }

    .col_big {
      height: 152px;
      width: 49.5%;
      // height: 100%;
      // padding: 22px 0;
      position: relative;

      .part1 {
        width: 50%;
        border-right: 1px solid #202C43;
        margin: 22px 0;
        cursor: pointer;

        .right {
          flex: 1;

          .item {
            .label {
              .ico {
                background: linear-gradient(360deg, rgba(21, 154, 255, 0) 0%, #159AFF 100%);
              }
            }

            .i0 {
              width: 50%;
            }
          }
        }
      }

      .part2 {
        width: 50%;

        .left {
          box-sizing: border-box;
          padding: 22px 0 22px 40px;
          padding-left: 8%;
          width: 56.5%;

          .radio-group {
            margin: 0;

            /deep/.el-radio-group {
              overflow: hidden;

              .el-radio-button {
                width: 100%;

                &:not(:last-of-type) {
                  margin-bottom: 10px;
                }

                .el-radio-button__inner {
                  border-radius: 0;
                  background: rgba(0, 0, 0, 0.2);
                  border-color: rgba(0, 0, 0, 0.2);
                  border-left: 1px solid rgba(0, 0, 0, 0.2);
                  color: #D0DEEE;
                  font-size: 14px;
                  padding: 16px 15px 16px 10px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  width: 100%;

                  .ico {
                    width: 15px;
                    height: 10px;
                    background: url(../assets/img/eye_nor.png) no-repeat top center;
                    margin-right: 10px;
                  }

                  .val {
                    // width: 56px;
                    width: 20%;
                    text-align: right;
                    font-size: 16px;
                    color: #F3F9FF;
                  }
                }

                &.is-active {
                  .el-radio-button__inner {
                    // border-color: #1598FB;
                    border-color: rgba(0, 0, 0, 0.2);

                    .ico {
                      background: url(../assets/img/eye_act.png) no-repeat top center;
                    }
                  }
                }
              }
            }
          }
        }

        .right {
          width: 43.4%;
        }
      }
    }

    .col_s_2 {
      padding: 0;

      .left {
        width: 48.9%;
        height: 65.8%;
        background: rgba(0, 0, 0, 0.2);
        padding: 0 6% 0 6.4%;
        box-sizing: border-box;
        margin: 22px 0;

        .item {
          text-align: center;

          .label {
            font-size: 14px;
            color: #D0DEEE;
          }

          .value {
            font-size: 16px;
            color: #F3F9FF;
            margin-top: 13px;
          }

          &.item1 {
            .value {
              color: #FF3838;
            }
          }
        }
      }

      .right {
        width: 50.9%;
      }
    }
  }

  .row2 {
    margin: 21px 30px 20px;
    // height: 28.1%;

    .card {
      height: 304px;
      // height: 100%;

      .cont {
        height: 84.2%;

        .chart {
          height: 100%;
        }

        #chart6 {
          position: relative;

          &::after {
            content: '单位：万元';
            position: absolute;
            left: 17px;
            top: 18px;
            color: #6C8097;
            font-size: 12px;
          }
        }

        #chart6 {
          &::after {
            left: 12px;
            top: 0px;
          }
        }
      }
    }

    .col1 {
      width: 39.4%;
    }

    .col2 {
      width: 24.2%;
    }

    .col3 {
      width: 34.3%;

      .tit {
        .right {
          font-size: 14px;

          .lab {
            color: #6C8097;
          }

          .val {
            color: #EBF9FF;
            text-shadow: 0px 0px 9px #159AFF;
            margin: 0 15px 0 10px;
          }
        }
      }

      .cont {
        overflow: hidden;
        height: 84.2%;
        cursor: pointer;

        .up {
          margin-top: 15px;

          .item {
            width: 196px;
            height: 39px;
            line-height: 39px;
            background: rgba(0, 0, 0, 0.2);
            font-size: 13px;
            padding: 0 10px 0 20px;
            position: relative;

            &::before {
              content: '';
              position: absolute;
              left: 10px;
              top: 17px;
              width: 5px;
              height: 5px;
              background: #1598FB;
            }

            &.item1 {
              margin-left: 10px;

              &::before {
                background: #2DD2A5;
              }
            }

            .lab {
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              color: #D0DEEE;
            }

            .val {
              font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
              color: #FFFFFF;
            }
          }
        }

        .down {
          height: 79.3%;

          .left {
            width: 50.9%;
          }

          .right {
            flex: 1;
          }
        }
      }
    }
  }

  .row3 {
    margin: 0 30px 39px;
    // height: 28.1%;

    .card {
      height: 304px;
      // height: 100%;

      .cont {
        height: 84.2%;

        .chart {
          height: 100%;
        }
      }
    }

    .col1 {
      width: 69.7%;

      .tit {
        .right {
          .radio-group {
            margin: 0;

            /deep/ .el-radio-group {
              .el-radio-button {
                .el-radio-button__inner {
                  background: transparent;
                  border: 0 none;
                }

                &.is-active {
                  .el-radio-button__inner {
                    box-shadow: none;

                    &::after {
                      content: '';
                      position: absolute;
                      top: 31px;
                      left: 50%;
                      transform: translate(-50%);
                      width: 16px;
                      height: 3px;
                      background: #1598FB;
                      border-radius: 10px 10px 10px 10px;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .cont {
        .left {
          padding: 15px 0 15px 15px;
          flex-wrap: wrap;
          width: 55.6%;

          .item {
            // width: 224px;
            width: 200px;
            height: 105px;
            background: rgba(0, 0, 0, 0.2);
            text-align: center;
            padding: 17px 0;
            margin-right: 15px;

            &:nth-of-type(3n) {
              margin-right: 0;
            }

            &:nth-of-type(1) {
              margin-bottom: 15px;
            }

            .value {
              margin-top: 7px;
              height: 21px;
              line-height: 21px;
            }

            .diff {
              margin-top: 17px;
            }
          }
        }

        .right {
          flex: 1;

          .item {
            width: 50%;
            cursor: pointer;

            .con {
              // 外圈背景
              background: url(../assets/img/index_circle_bg_2.png) no-repeat center center;
            }

            .mask {
              // 内圈背景
              width: 88px;
              height: 88px;
              background: url(../assets/img/index_circle_bg_2.png) no-repeat center center;
            }
          }

        }
      }
    }

    .col2 {
      width: 29.2%;

      .cont {
        overflow: hidden;
        position: relative;

        .up {
          margin: 15px 25px 0;
          background: rgba(0, 0, 0, 0.2);
          height: 67px;
          padding: 15px 25px;
          box-sizing: border-box;
          cursor: pointer;

          .l {
            // width: 200px;
            width: 40.5%;
            // width: 80%;
            align-items: center;

            .lab {
              padding-left: 11px;
              line-height: 14px;
              height: 14px;
              font-size: 14px;
              color: #D0DEEE;
              position: relative;

              &::before {
                content: '';
                position: absolute;
                left: 0;
                width: 3px;
                height: 14px;
                background: #1598FB;
              }
            }

            .val {
              font-size: 18px;
              font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
              color: #FFF4E3;
              text-shadow: 0px 0px 10px rgba(255, 201, 122, 1);
              margin-left: 20px;
            }
          }

          .r {
            flex-wrap: wrap;
            font-size: 13px;
            width: 51.6%;

            .item {
              height: 13px;
              line-height: 13px;
              width: 44%;

              .lab {
                color: #D0DEEE;
              }

              .val {
                color: #FFFFFF;
              }

              &:nth-child(1) {
                margin-bottom: 11px;
              }

              &:nth-child(2) {
                margin-bottom: 11px;
              }
            }
          }
        }

        .down {
          // height: 57.4%;
          height: 64%;
        }
      }
    }
  }

  .row3 {
    .card {
      .cont {
        #chart9 {
          position: relative;

          &::after {
            content: '单位：万元';
            position: absolute;
            right: 17px;
            top: 18px;
            color: #6C8097;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
